const formatShortCount = (value) => {
    const v = Number(value || 0)
    if (v >= 1000000) return `${(v / 1000000).toFixed(1)}m`
    if (v >= 1000) return `${(v / 1000).toFixed(1)}k`
    return v.toLocaleString()
}

module.exports = function (provider, targetToken, field, options) {
    const root = options?.data?.root || {}
    const scope = (options?.hash?.scope || 'website').toString()
    const isSourceToken = /^source:/i.test(String(targetToken || ''))
    const scopedToken = !isSourceToken && scope && scope !== 'website'
        ? `${targetToken}|scope:${scope}`
        : targetToken
    let value = root?.reviews?.[provider]?.[scopedToken]?.[field]
    if (value === undefined) {
        value = root?.reviews?.[provider]?.[targetToken]?.[field]
    }

    if (field === 'avg') {
        const precision = Number(options?.hash?.precision ?? 1)
        return typeof value === 'number' ? value.toFixed(precision) : (value ?? '')
    }

    if (field === 'count') {
        const short = options?.hash?.short === true || options?.hash?.short === 'true'
        if (typeof value !== 'number') return value ?? ''
        return short ? formatShortCount(value) : value.toLocaleString()
    }

    return value ?? ''
}
